export default {
  role: {
    owner: 'Proprietário',
    admin: 'Administrador',
    basic: 'Básico',
    member: 'Membro',
  },
  detection: {
    never_detected: 'Nunca detectado',
    recent: 'Detectado agora',
    stale: 'Desatualizado',
    unknown: 'Sem dados',
  },
  activation: {
    not_activated: 'Não ativado',
    provisioning: 'Em provisionamento',
    active: 'Ativado',
    failed: 'Falha na ativação',
    revoked: 'Revogado',
  },
  category: {
    vehicle: 'Veículo',
    pet: 'Pet',
    object: 'Objeto',
    asset: 'Ativo',
  },
  category_plural: {
    vehicle: 'Veículos',
    pet: 'Pets',
    object: 'Objetos',
    asset: 'Ativos',
  },
  alert_kind: {
    geofence_exit: 'Saiu da cerca',
    geofence_enter: 'Entrou na cerca',
    battery_low: 'Bateria fraca',
    device_offline: 'Dispositivo offline',
    sos: 'SOS',
    speed: 'Velocidade',
    generic: 'Alerta',
  },
  sharing_state: {
    active: 'Ativo',
    paused: 'Pausado',
    revoked: 'Revogado',
    inactive: 'Inativo',
  },
  subscription_state: {
    pending: 'Pendente',
    active: 'Ativa',
    overdue: 'Em atraso',
    suspended: 'Suspensa',
    canceled: 'Cancelada',
  },
  order_state: {
    draft: 'Rascunho',
    pending_payment: 'Aguardando pagamento',
    paid: 'Pago',
    fulfillment: 'Em separação',
    partially_shipped: 'Envio parcial',
    shipped: 'Enviado',
    delivered: 'Entregue',
    completed: 'Concluído',
    canceled: 'Cancelado',
    refunded: 'Estornado',
  },
  source: {
    ble: 'Localizador',
    mobile: 'Rastreador',
    gps: 'GPS',
    wifi: 'Wi-Fi',
    network: 'Rede',
  },
  order_status: {
    pending: 'Pendente',
    paid: 'Pago',
    cancelled: 'Cancelado',
    refunded: 'Reembolsado',
    fulfilled: 'Entregue',
  },
  account_type: {
    personal: 'Personal',
    professional: 'Professional',
  },
  pairing_state: {
    pending: 'Aguardando o app',
    claimed: 'Código digitado no app',
    consented: 'Consentimento confirmado no app',
    approved: 'Aprovado — finalizando',
    completed: 'Pareado',
    expired: 'Expirado',
    cancelled: 'Cancelado',
  },
  mobile_sharing_state: {
    active: 'Compartilhando',
    paused: 'Pausado no aparelho',
    stopped: 'Parado',
    unlinked: 'Desvinculado',
  },
}
